<template>
<!-- This is Resuble component for delete Item confirmation -->
    <div v-if="showDeleteModal" tabindex="0"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="dialogTitleId"
        :class="elevated ? 'z-[60]' : 'z-40'"
        class="overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed">
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full"
            style="width: 500px;"
            @click.stop>
            <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
                <div class="sm:flex sm:items-start">
                <div
                    class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"
                    :class="variant === 'primary' ? 'bg-[#d9f9f9]' : 'bg-red-100'"
                >
                    <!-- Heroicon name: outline/exclamation -->
                    <svg
                        class="h-6 w-6"
                        :class="variant === 'primary' ? 'text-[#1f3341]' : 'text-red-600'"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <p
                        :id="dialogTitleId"
                        class="text-2xl leading-6 font-medium"
                        :class="variant === 'primary' ? 'text-[#1f3341]' : 'text-red-600'"
                    >
                    {{title}}!
                    </p>
                    <div class="mt-2">
                        <p class="text-sm text-gray-500 pt-2 pb-2">
                            {{msg}}
                        </p>
                    </div>
                </div>
                </div>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                        type="button"
                        @click.stop="$emit('remove', $event)"
                        :class="confirmButtonClass || defaultConfirmButtonClass"
                    >
                    {{ confirmLabel }}
                    </button>
                    <button type="button" @click.stop="$emit('click', $event)" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                    {{ cancelLabel }}
                    </button>
                </div>
            </div>
        </div>
        <div
            class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
            @click="$emit('click', $event)"
        ></div>
    </div>
</template>
<script>
export default {
    name: 'modalConfirm',
    inheritAttrs: false,
    props: {
        title: String,
        msg: String,
        showDeleteModal:Boolean,
        sort_msg: String,
        confirmLabel: {
            type: String,
            default: "DELETE",
        },
        cancelLabel: {
            type: String,
            default: "Cancel",
        },
        confirmButtonClass: {
            type: String,
            default: "",
        },
        variant: {
            type: String,
            default: "danger",
        },
        elevated: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dialogTitleId() {
            const slug = String(this.title || "dialog")
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-");
            return `confirm-dialog-title-${slug}`;
        },
        defaultConfirmButtonClass() {
            return "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm";
        },
    },
};
</script>